import { useQuery } from '@tanstack/react-query';
import type { EvalTypeMetadata } from '@/types/eval-v2-types';
import { getEvalTypes } from '@/services/evaluation/get-eval-types';

export const EVAL_TYPES_QUERY_KEY = 'eval-types';

/** Fetches the eval type catalog. The catalog is essentially static, so we
 *  keep it cached for 5 minutes to avoid redundant calls when the user
 *  navigates between eval builder tabs. */
export const useGetEvalTypes = () =>
  useQuery<EvalTypeMetadata[], Error>({
    queryKey: [EVAL_TYPES_QUERY_KEY],
    queryFn: getEvalTypes,
    staleTime: 5 * 60 * 1000,
  });

/** Look up the full metadata (description, sections, tip) for an eval type.
 *  Returns undefined while loading or if the type is missing from the
 *  catalog, so callers can gracefully render nothing. */
export const useEvalTypeMetadata = (
  typeId: string,
): EvalTypeMetadata | undefined => {
  const { data } = useGetEvalTypes();
  return data?.find((t) => t.id === typeId);
};
